export const PACKAGE_STATUS_AWAITING_PAYMENT = 1;
export const PACKAGE_STATUS_PAID = 2;
export const PACKAGE_STATUS_PENDING = 3;
export const PACKAGE_STATUS_RUNNING = 4;
export const PACKAGE_STATUS_COMPLETED = 5;
